import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { getHeight } from './checklist-field.util';

export const fieldLabelTextStyle = css`
  margin-bottom: ${theme.spacing(0.5)};
`;

export const multipleItemsLabelContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  flex-wrap: wrap;
`;

export const labelTextStyle = css`
  color: ${theme.colors.text.subdued};
`;

export const searchFieldContainerStyle = css`
  margin-bottom: ${theme.spacing(1)};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${theme.spacing(1)};
`;

export const actionsContainerStyle = css`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing(1)};
`;

export const clearButtonStyle = css`
  margin-left: auto;
`;

export const popoverContentStyle = css`
  padding: ${theme.spacing(1.5)};
  min-width: 280px;
`;

export const triggerButtonStyle = css`
  padding: ${theme.spacing(1, 2)};
  border: 1px solid ${theme.colors.neutral30};
  border-radius: ${theme.borderRadius.small};
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    border-color: ${theme.colors.primary50};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary50};
  }
`;

export const getTriggerButtonStyle = (hasError: boolean) => css`
  ${triggerButtonStyle};
  ${hasError &&
  css`
    border-color: ${theme.colors.critical50};

    &:hover {
      border-color: ${theme.colors.critical50};
    }

    &:focus {
      border-color: ${theme.colors.critical50};
    }
  `}
`;

export const errorMessageStyle = css`
  color: ${theme.colors.critical50};
  margin-top: ${theme.spacing(0.5)};
`;

export const checkboxContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  margin-top: ${theme.spacing(1)};
`;

export const listItemStyle = css`
  padding: ${theme.spacing(1)};
`;

export const getCheckboxListStyle = (numberOfItems: number) => css`
  height: ${getHeight(numberOfItems)};
`;

export const noResultsContainerStyle = css`
  padding: ${theme.spacing(2)};
  text-align: center;
  color: ${theme.colors.text.subdued};
`;
